import { combineReducers } from 'redux';
import { StepReducer, realizarFormalizacionCreditoReducer, cursarCreditoReducer,autorizacionReducer, seguroReducer } from '../domain/common/Step/StepsReducer';
import { ObtenerDatosBasicosReducer, ObtenerCampanaReducer, ObtenerIndicadorCurse, ObtenerConsultarDetalleDeSolicitud, ObtenerSimulacionReducer, sessionReducer, solicitarReducer, enviarSoliciturReducer, UpdateDatosReducer, webViuwReducer } from '../domain/main/MainReducer';
import LoaderReducer from '../domain/common/loader/LoaderReducer';
import ModalErrorReducer from '../domain/main/ModalErrorReducer';
import ModalEncuestaReducer from '../domain/encuesta/ModalEncuestaReducer';
import obternerEnfermedadesPreExistentes from '../domain/common/enfermedadPreexistente/EnfermedadPreexisteReducer';
import { cargarDocumentoReducer } from '../domain/common/InputFileUpper/inputFileUpperReduce';
import RechazoReducer from '../domain/rechazo/RechazoReducer'



const rootReducer = combineReducers({
    step: StepReducer,
    obtenerCampanaUsuario: ObtenerCampanaReducer,
    datosPersona: ObtenerDatosBasicosReducer,
    datosPersonaUpdate: UpdateDatosReducer,
    formalizarCredito: realizarFormalizacionCreditoReducer,
    // documentosCredito: obtenerDocumentosReducer,
    cursarCredito: cursarCreditoReducer,
    loader: LoaderReducer,
    modalError: ModalErrorReducer,
    modalEncuesta: ModalEncuestaReducer,
    indicadorCurse: ObtenerIndicadorCurse,
    consultarDetalleDeSolicitud: ObtenerConsultarDetalleDeSolicitud,
    autorizacion: autorizacionReducer,
    sessionUsuario: sessionReducer,
    simulacion: ObtenerSimulacionReducer,
    listaDeEnfermedades: obternerEnfermedadesPreExistentes,
    solicitar:solicitarReducer,
    documentos: cargarDocumentoReducer,
    rechazo: RechazoReducer,
    enviarSolicitudDocumentos: enviarSoliciturReducer,
    seguros: seguroReducer,
    webViuw: webViuwReducer
});

export default rootReducer;
